import { default as adhocwjzFbJzfU1Meta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/adhoc.vue?macro=true";
import { default as moderationReviewEOSDn6tRsVMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/moderationReview.vue?macro=true";
import { default as permissionsy6I3oag2NdMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/permissions.vue?macro=true";
import { default as playersfMvSXJDIxfMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/players.vue?macro=true";
import { default as projectsp962myqeQdMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/projects.vue?macro=true";
import { default as roles3uxrV8J6tuMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/roles.vue?macro=true";
import { default as serverEnvironmentsPPgff27e5gMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/serverEnvironments.vue?macro=true";
import { default as sidebarItemGHUSOzwvPwMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/sidebarItem.vue?macro=true";
import { default as usersw8cI2VKx0sMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/users.vue?macro=true";
import { default as ForgotPasswordeOXcWUPSrSMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/ForgotPassword.vue?macro=true";
import { default as forgotPasswordTokenYbtAoPLPtyMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/forgotPasswordToken.vue?macro=true";
import { default as indexrLKxiaIR2LMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/index.vue?macro=true";
import { default as RegisterjRS60fBuo0Meta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/Register.vue?macro=true";
import { default as resetPassword5FusoiWlicMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/resetPassword.vue?macro=true";
import { default as buckets3UrPQm6eUDMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/buckets.vue?macro=true";
import { default as content_45itemsonvxliwqJBMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/content-items.vue?macro=true";
import { default as content_45typesXZHqHXFUkWMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/content-types.vue?macro=true";
import { default as contractsZkTobnIAG4Meta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/contracts.vue?macro=true";
import { default as daresfTtmDSTV5yMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/dares.vue?macro=true";
import { default as formulasc3REcT7z6eMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/formulas.vue?macro=true";
import { default as gamecontexts6V8SCx9PbCMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/gamecontexts.vue?macro=true";
import { default as imageTypesoWlzAe7s1SMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/imageTypes.vue?macro=true";
import { default as indexllxqx3tXpgMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/index.vue?macro=true";
import { default as leaderboardseCkLnKCnopMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/leaderboards.vue?macro=true";
import { default as locationrp08VzMuSkMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/location.vue?macro=true";
import { default as logspnpE17z2ISMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/logs.vue?macro=true";
import { default as migration_45audit_45historyVykxf5v5eWMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/migration-audit-history.vue?macro=true";
import { default as migration_45dependency_45maphwKq1IbsBMMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/migration-dependency-map.vue?macro=true";
import { default as migrationsRQ9KNCUFrkMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/migrations.vue?macro=true";
import { default as profileCvC30jfjwpMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/profile.vue?macro=true";
import { default as progressionMilestonesZYqRyAzpM3Meta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/progressionMilestones.vue?macro=true";
import { default as progressionsIbZJzBbEPrMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/progressions.vue?macro=true";
import { default as progressionsAddStep101Ew1lvcxNMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/progressionsAddStep1.vue?macro=true";
import { default as savepointsmCAfU42F5oMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/savepoints.vue?macro=true";
import { default as scheduledJobsjhcfRPtuJ9Meta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/scheduledJobs.vue?macro=true";
import { default as serverseI6N4JP3aXMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/servers.vue?macro=true";
import { default as store_organizenXpSYH0aJCMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/store_organize.vue?macro=true";
import { default as storeC7y1VZrUEVMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/store.vue?macro=true";
import { default as storeTransactionskrrbAlzoDYMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/storeTransactions.vue?macro=true";
import { default as tagsX7tlsI0ARbMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/tags.vue?macro=true";
import { default as tournamentLocations65LwA5C8M4Meta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/tournamentLocations.vue?macro=true";
import { default as tournamentsmb2YDFvCzfMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/tournaments.vue?macro=true";
import { default as UnauthorizedKs5fFIpl3ZMeta } from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/Unauthorized.vue?macro=true";
export default [
  {
    name: adhocwjzFbJzfU1Meta?.name ?? "adhoc",
    path: adhocwjzFbJzfU1Meta?.path ?? "/adhoc",
    meta: adhocwjzFbJzfU1Meta || {},
    alias: adhocwjzFbJzfU1Meta?.alias || [],
    redirect: adhocwjzFbJzfU1Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/adhoc.vue").then(m => m.default || m)
  },
  {
    name: moderationReviewEOSDn6tRsVMeta?.name ?? "admin-moderationReview",
    path: moderationReviewEOSDn6tRsVMeta?.path ?? "/admin/moderationReview",
    meta: moderationReviewEOSDn6tRsVMeta || {},
    alias: moderationReviewEOSDn6tRsVMeta?.alias || [],
    redirect: moderationReviewEOSDn6tRsVMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/moderationReview.vue").then(m => m.default || m)
  },
  {
    name: permissionsy6I3oag2NdMeta?.name ?? "admin-permissions",
    path: permissionsy6I3oag2NdMeta?.path ?? "/admin/permissions",
    meta: permissionsy6I3oag2NdMeta || {},
    alias: permissionsy6I3oag2NdMeta?.alias || [],
    redirect: permissionsy6I3oag2NdMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/permissions.vue").then(m => m.default || m)
  },
  {
    name: playersfMvSXJDIxfMeta?.name ?? "admin-players",
    path: playersfMvSXJDIxfMeta?.path ?? "/admin/players",
    meta: playersfMvSXJDIxfMeta || {},
    alias: playersfMvSXJDIxfMeta?.alias || [],
    redirect: playersfMvSXJDIxfMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/players.vue").then(m => m.default || m)
  },
  {
    name: projectsp962myqeQdMeta?.name ?? "admin-projects",
    path: projectsp962myqeQdMeta?.path ?? "/admin/projects",
    meta: projectsp962myqeQdMeta || {},
    alias: projectsp962myqeQdMeta?.alias || [],
    redirect: projectsp962myqeQdMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/projects.vue").then(m => m.default || m)
  },
  {
    name: roles3uxrV8J6tuMeta?.name ?? "admin-roles",
    path: roles3uxrV8J6tuMeta?.path ?? "/admin/roles",
    meta: roles3uxrV8J6tuMeta || {},
    alias: roles3uxrV8J6tuMeta?.alias || [],
    redirect: roles3uxrV8J6tuMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/roles.vue").then(m => m.default || m)
  },
  {
    name: serverEnvironmentsPPgff27e5gMeta?.name ?? "admin-serverEnvironments",
    path: serverEnvironmentsPPgff27e5gMeta?.path ?? "/admin/serverEnvironments",
    meta: serverEnvironmentsPPgff27e5gMeta || {},
    alias: serverEnvironmentsPPgff27e5gMeta?.alias || [],
    redirect: serverEnvironmentsPPgff27e5gMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/serverEnvironments.vue").then(m => m.default || m)
  },
  {
    name: sidebarItemGHUSOzwvPwMeta?.name ?? "admin-sidebarItem",
    path: sidebarItemGHUSOzwvPwMeta?.path ?? "/admin/sidebarItem",
    meta: sidebarItemGHUSOzwvPwMeta || {},
    alias: sidebarItemGHUSOzwvPwMeta?.alias || [],
    redirect: sidebarItemGHUSOzwvPwMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/sidebarItem.vue").then(m => m.default || m)
  },
  {
    name: usersw8cI2VKx0sMeta?.name ?? "admin-users",
    path: usersw8cI2VKx0sMeta?.path ?? "/admin/users",
    meta: usersw8cI2VKx0sMeta || {},
    alias: usersw8cI2VKx0sMeta?.alias || [],
    redirect: usersw8cI2VKx0sMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: ForgotPasswordeOXcWUPSrSMeta?.name ?? "auth-ForgotPassword",
    path: ForgotPasswordeOXcWUPSrSMeta?.path ?? "/auth/ForgotPassword",
    meta: ForgotPasswordeOXcWUPSrSMeta || {},
    alias: ForgotPasswordeOXcWUPSrSMeta?.alias || [],
    redirect: ForgotPasswordeOXcWUPSrSMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/ForgotPassword.vue").then(m => m.default || m)
  },
  {
    name: forgotPasswordTokenYbtAoPLPtyMeta?.name ?? "auth-forgotPasswordToken",
    path: forgotPasswordTokenYbtAoPLPtyMeta?.path ?? "/auth/forgotPasswordToken",
    meta: forgotPasswordTokenYbtAoPLPtyMeta || {},
    alias: forgotPasswordTokenYbtAoPLPtyMeta?.alias || [],
    redirect: forgotPasswordTokenYbtAoPLPtyMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/forgotPasswordToken.vue").then(m => m.default || m)
  },
  {
    name: indexrLKxiaIR2LMeta?.name ?? "auth",
    path: indexrLKxiaIR2LMeta?.path ?? "/auth",
    meta: indexrLKxiaIR2LMeta || {},
    alias: indexrLKxiaIR2LMeta?.alias || [],
    redirect: indexrLKxiaIR2LMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/index.vue").then(m => m.default || m)
  },
  {
    name: RegisterjRS60fBuo0Meta?.name ?? "auth-Register",
    path: RegisterjRS60fBuo0Meta?.path ?? "/auth/Register",
    meta: RegisterjRS60fBuo0Meta || {},
    alias: RegisterjRS60fBuo0Meta?.alias || [],
    redirect: RegisterjRS60fBuo0Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/Register.vue").then(m => m.default || m)
  },
  {
    name: resetPassword5FusoiWlicMeta?.name ?? "auth-resetPassword",
    path: resetPassword5FusoiWlicMeta?.path ?? "/auth/resetPassword",
    meta: resetPassword5FusoiWlicMeta || {},
    alias: resetPassword5FusoiWlicMeta?.alias || [],
    redirect: resetPassword5FusoiWlicMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/auth/resetPassword.vue").then(m => m.default || m)
  },
  {
    name: buckets3UrPQm6eUDMeta?.name ?? "buckets",
    path: buckets3UrPQm6eUDMeta?.path ?? "/buckets",
    meta: buckets3UrPQm6eUDMeta || {},
    alias: buckets3UrPQm6eUDMeta?.alias || [],
    redirect: buckets3UrPQm6eUDMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/buckets.vue").then(m => m.default || m)
  },
  {
    name: content_45itemsonvxliwqJBMeta?.name ?? "content-items",
    path: content_45itemsonvxliwqJBMeta?.path ?? "/content-items",
    meta: content_45itemsonvxliwqJBMeta || {},
    alias: content_45itemsonvxliwqJBMeta?.alias || [],
    redirect: content_45itemsonvxliwqJBMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/content-items.vue").then(m => m.default || m)
  },
  {
    name: content_45typesXZHqHXFUkWMeta?.name ?? "content-types",
    path: content_45typesXZHqHXFUkWMeta?.path ?? "/content-types",
    meta: content_45typesXZHqHXFUkWMeta || {},
    alias: content_45typesXZHqHXFUkWMeta?.alias || [],
    redirect: content_45typesXZHqHXFUkWMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/content-types.vue").then(m => m.default || m)
  },
  {
    name: contractsZkTobnIAG4Meta?.name ?? "contracts",
    path: contractsZkTobnIAG4Meta?.path ?? "/contracts",
    meta: contractsZkTobnIAG4Meta || {},
    alias: contractsZkTobnIAG4Meta?.alias || [],
    redirect: contractsZkTobnIAG4Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/contracts.vue").then(m => m.default || m)
  },
  {
    name: daresfTtmDSTV5yMeta?.name ?? "dares",
    path: daresfTtmDSTV5yMeta?.path ?? "/dares",
    meta: daresfTtmDSTV5yMeta || {},
    alias: daresfTtmDSTV5yMeta?.alias || [],
    redirect: daresfTtmDSTV5yMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/dares.vue").then(m => m.default || m)
  },
  {
    name: formulasc3REcT7z6eMeta?.name ?? "formulas",
    path: formulasc3REcT7z6eMeta?.path ?? "/formulas",
    meta: formulasc3REcT7z6eMeta || {},
    alias: formulasc3REcT7z6eMeta?.alias || [],
    redirect: formulasc3REcT7z6eMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/formulas.vue").then(m => m.default || m)
  },
  {
    name: gamecontexts6V8SCx9PbCMeta?.name ?? "gamecontexts",
    path: gamecontexts6V8SCx9PbCMeta?.path ?? "/gamecontexts",
    meta: gamecontexts6V8SCx9PbCMeta || {},
    alias: gamecontexts6V8SCx9PbCMeta?.alias || [],
    redirect: gamecontexts6V8SCx9PbCMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/gamecontexts.vue").then(m => m.default || m)
  },
  {
    name: imageTypesoWlzAe7s1SMeta?.name ?? "imageTypes",
    path: imageTypesoWlzAe7s1SMeta?.path ?? "/imageTypes",
    meta: imageTypesoWlzAe7s1SMeta || {},
    alias: imageTypesoWlzAe7s1SMeta?.alias || [],
    redirect: imageTypesoWlzAe7s1SMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/imageTypes.vue").then(m => m.default || m)
  },
  {
    name: indexllxqx3tXpgMeta?.name ?? "index",
    path: indexllxqx3tXpgMeta?.path ?? "/",
    meta: indexllxqx3tXpgMeta || {},
    alias: indexllxqx3tXpgMeta?.alias || [],
    redirect: indexllxqx3tXpgMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/index.vue").then(m => m.default || m)
  },
  {
    name: leaderboardseCkLnKCnopMeta?.name ?? "leaderboards",
    path: leaderboardseCkLnKCnopMeta?.path ?? "/leaderboards",
    meta: leaderboardseCkLnKCnopMeta || {},
    alias: leaderboardseCkLnKCnopMeta?.alias || [],
    redirect: leaderboardseCkLnKCnopMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/leaderboards.vue").then(m => m.default || m)
  },
  {
    name: locationrp08VzMuSkMeta?.name ?? "location",
    path: locationrp08VzMuSkMeta?.path ?? "/location",
    meta: locationrp08VzMuSkMeta || {},
    alias: locationrp08VzMuSkMeta?.alias || [],
    redirect: locationrp08VzMuSkMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/location.vue").then(m => m.default || m)
  },
  {
    name: logspnpE17z2ISMeta?.name ?? "logs",
    path: logspnpE17z2ISMeta?.path ?? "/logs",
    meta: logspnpE17z2ISMeta || {},
    alias: logspnpE17z2ISMeta?.alias || [],
    redirect: logspnpE17z2ISMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/logs.vue").then(m => m.default || m)
  },
  {
    name: migration_45audit_45historyVykxf5v5eWMeta?.name ?? "migration-audit-history",
    path: migration_45audit_45historyVykxf5v5eWMeta?.path ?? "/migration-audit-history",
    meta: migration_45audit_45historyVykxf5v5eWMeta || {},
    alias: migration_45audit_45historyVykxf5v5eWMeta?.alias || [],
    redirect: migration_45audit_45historyVykxf5v5eWMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/migration-audit-history.vue").then(m => m.default || m)
  },
  {
    name: migration_45dependency_45maphwKq1IbsBMMeta?.name ?? "migration-dependency-map",
    path: migration_45dependency_45maphwKq1IbsBMMeta?.path ?? "/migration-dependency-map",
    meta: migration_45dependency_45maphwKq1IbsBMMeta || {},
    alias: migration_45dependency_45maphwKq1IbsBMMeta?.alias || [],
    redirect: migration_45dependency_45maphwKq1IbsBMMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/migration-dependency-map.vue").then(m => m.default || m)
  },
  {
    name: migrationsRQ9KNCUFrkMeta?.name ?? "migrations",
    path: migrationsRQ9KNCUFrkMeta?.path ?? "/migrations",
    meta: migrationsRQ9KNCUFrkMeta || {},
    alias: migrationsRQ9KNCUFrkMeta?.alias || [],
    redirect: migrationsRQ9KNCUFrkMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/migrations.vue").then(m => m.default || m)
  },
  {
    name: profileCvC30jfjwpMeta?.name ?? "profile",
    path: profileCvC30jfjwpMeta?.path ?? "/profile",
    meta: profileCvC30jfjwpMeta || {},
    alias: profileCvC30jfjwpMeta?.alias || [],
    redirect: profileCvC30jfjwpMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: progressionMilestonesZYqRyAzpM3Meta?.name ?? "progressionMilestones",
    path: progressionMilestonesZYqRyAzpM3Meta?.path ?? "/progressionMilestones",
    meta: progressionMilestonesZYqRyAzpM3Meta || {},
    alias: progressionMilestonesZYqRyAzpM3Meta?.alias || [],
    redirect: progressionMilestonesZYqRyAzpM3Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/progressionMilestones.vue").then(m => m.default || m)
  },
  {
    name: progressionsIbZJzBbEPrMeta?.name ?? "progressions",
    path: progressionsIbZJzBbEPrMeta?.path ?? "/progressions",
    meta: progressionsIbZJzBbEPrMeta || {},
    alias: progressionsIbZJzBbEPrMeta?.alias || [],
    redirect: progressionsIbZJzBbEPrMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/progressions.vue").then(m => m.default || m)
  },
  {
    name: progressionsAddStep101Ew1lvcxNMeta?.name ?? "progressionsAddStep1",
    path: progressionsAddStep101Ew1lvcxNMeta?.path ?? "/progressionsAddStep1",
    meta: progressionsAddStep101Ew1lvcxNMeta || {},
    alias: progressionsAddStep101Ew1lvcxNMeta?.alias || [],
    redirect: progressionsAddStep101Ew1lvcxNMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/progressionsAddStep1.vue").then(m => m.default || m)
  },
  {
    name: savepointsmCAfU42F5oMeta?.name ?? "savepoints",
    path: savepointsmCAfU42F5oMeta?.path ?? "/savepoints",
    meta: savepointsmCAfU42F5oMeta || {},
    alias: savepointsmCAfU42F5oMeta?.alias || [],
    redirect: savepointsmCAfU42F5oMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/savepoints.vue").then(m => m.default || m)
  },
  {
    name: scheduledJobsjhcfRPtuJ9Meta?.name ?? "scheduledJobs",
    path: scheduledJobsjhcfRPtuJ9Meta?.path ?? "/scheduledJobs",
    meta: scheduledJobsjhcfRPtuJ9Meta || {},
    alias: scheduledJobsjhcfRPtuJ9Meta?.alias || [],
    redirect: scheduledJobsjhcfRPtuJ9Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/scheduledJobs.vue").then(m => m.default || m)
  },
  {
    name: serverseI6N4JP3aXMeta?.name ?? "servers",
    path: serverseI6N4JP3aXMeta?.path ?? "/servers",
    meta: serverseI6N4JP3aXMeta || {},
    alias: serverseI6N4JP3aXMeta?.alias || [],
    redirect: serverseI6N4JP3aXMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/servers.vue").then(m => m.default || m)
  },
  {
    name: store_organizenXpSYH0aJCMeta?.name ?? "store_organize",
    path: store_organizenXpSYH0aJCMeta?.path ?? "/store_organize",
    meta: store_organizenXpSYH0aJCMeta || {},
    alias: store_organizenXpSYH0aJCMeta?.alias || [],
    redirect: store_organizenXpSYH0aJCMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/store_organize.vue").then(m => m.default || m)
  },
  {
    name: storeC7y1VZrUEVMeta?.name ?? "store",
    path: storeC7y1VZrUEVMeta?.path ?? "/store",
    meta: storeC7y1VZrUEVMeta || {},
    alias: storeC7y1VZrUEVMeta?.alias || [],
    redirect: storeC7y1VZrUEVMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/store.vue").then(m => m.default || m)
  },
  {
    name: storeTransactionskrrbAlzoDYMeta?.name ?? "storeTransactions",
    path: storeTransactionskrrbAlzoDYMeta?.path ?? "/storeTransactions",
    meta: storeTransactionskrrbAlzoDYMeta || {},
    alias: storeTransactionskrrbAlzoDYMeta?.alias || [],
    redirect: storeTransactionskrrbAlzoDYMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/storeTransactions.vue").then(m => m.default || m)
  },
  {
    name: tagsX7tlsI0ARbMeta?.name ?? "tags",
    path: tagsX7tlsI0ARbMeta?.path ?? "/tags",
    meta: tagsX7tlsI0ARbMeta || {},
    alias: tagsX7tlsI0ARbMeta?.alias || [],
    redirect: tagsX7tlsI0ARbMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/tags.vue").then(m => m.default || m)
  },
  {
    name: tournamentLocations65LwA5C8M4Meta?.name ?? "tournamentLocations",
    path: tournamentLocations65LwA5C8M4Meta?.path ?? "/tournamentLocations",
    meta: tournamentLocations65LwA5C8M4Meta || {},
    alias: tournamentLocations65LwA5C8M4Meta?.alias || [],
    redirect: tournamentLocations65LwA5C8M4Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/tournamentLocations.vue").then(m => m.default || m)
  },
  {
    name: tournamentsmb2YDFvCzfMeta?.name ?? "tournaments",
    path: tournamentsmb2YDFvCzfMeta?.path ?? "/tournaments",
    meta: tournamentsmb2YDFvCzfMeta || {},
    alias: tournamentsmb2YDFvCzfMeta?.alias || [],
    redirect: tournamentsmb2YDFvCzfMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/tournaments.vue").then(m => m.default || m)
  },
  {
    name: UnauthorizedKs5fFIpl3ZMeta?.name ?? "Unauthorized",
    path: UnauthorizedKs5fFIpl3ZMeta?.path ?? "/Unauthorized",
    meta: UnauthorizedKs5fFIpl3ZMeta || {},
    alias: UnauthorizedKs5fFIpl3ZMeta?.alias || [],
    redirect: UnauthorizedKs5fFIpl3ZMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/pages/Unauthorized.vue").then(m => m.default || m)
  }
]